(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["contact-form"] && !Shopify.designMode) return;
  try {
    // Anti-spam: disable submit until the form has been on screen for at least 3 seconds
  document.querySelectorAll('.contact-form__form').forEach((form) => {
    const submitBtn = form.querySelector('[type="submit"], button:last-of-type');
    if (!submitBtn) return;

    submitBtn.disabled = true;
    setTimeout(() => { submitBtn.disabled = false; }, 3000);

    // Block submission if honeypot is filled
    form.addEventListener('submit', (e) => {
      const hp = form.querySelector('[name="contact[website]"]');
      if (hp && hp.value.length > 0) {
        e.preventDefault();
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
